import { ChatModuleType } from 'app/copied/models/ChatModules';
import useModule from 'app/hooks/useModule';

export default function usePdfViewerEnabled() {
  const kbMobule = useModule(ChatModuleType.TAIlor);

  return !!kbMobule?.config?.enable_hub_pdf_viewer;
}
